<template>
  <div class="layout-header">
    <div class="header-logo" @click="$router.push('/')">
      <div class="logo-icon">
        <t-icon name="member" />
      </div>
      会员管理系统
    </div>
    
    <div class="header-actions">
      <t-dropdown
        :options="userMenuOptions"
        placement="bottom-right"
        @click="handleUserMenuClick"
      >
        <div class="user-info">
          <t-avatar size="32px" :image="userInfo.avatar">
            {{ userInfo.name?.charAt(0) }}
          </t-avatar>
          <span v-if="!isMobile" class="user-name">{{ userInfo.name }}</span>
          <t-icon name="chevron-down" />
        </div>
      </t-dropdown>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import type { User } from '@/types/auth'

interface Props {
  isMobile?: boolean
  unreadCount?: number
}

withDefaults(defineProps<Props>(), {
  isMobile: false,
  unreadCount: 0
})

const router = useRouter()
const authStore = useAuthStore()
const { user } = storeToRefs(authStore)

const defaultUserInfo: User = {
  id: '',
  name: '访客',
  mobile: '',
  userType: 0,
  merchantId: null
}

const userInfo = computed(() => user.value ?? defaultUserInfo)

const userMenuOptions = [
  { content: '修改密码', value: 'password' },
  { content: '退出登录', value: 'logout' }
]

const handleUserMenuClick = async (data: any) => {
  if (data.value === 'password') {
    router.push('/profile/password')
  } else if (data.value === 'logout') {
    await authStore.logout()
  }
}
</script>

<style lang="less" scoped>
.user-info {
  display: flex;
  align-items: center;
  gap: var(--td-spacer-xs);
  padding: var(--td-spacer-xs) var(--td-spacer-s);
  border-radius: var(--td-radius-medium);
  background: var(--td-bg-color-container-hover);
  
  .user-name {
    font-size: var(--td-font-size-s);
    color: var(--td-text-color-primary);
  }
}
</style>
